// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
// api
import * as pa from './api/pa'

// thunks
export const fetchProductDataLastUpdated = createAsyncThunk(
    'product/fetchProductDataLastUpdated',
    async (product) => {
        const response = await pa.getProductDataLastUpdatedRequest(product);
        return response.data
    }
);